// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_profile_btn-primary__1M5GR","profile":"_profile_profile__1Lhrm","input-box":"_profile_input-box__3_Nde","btn-group":"_profile_btn-group__2wpkZ"};